<template>
  <div :class="{'webHeader':true, 'webHeader1':!isShow,'webHeader2':isShow}">
    <div class="webHeaderContent">
      <div class="logo1" @click="handleChange(1,'/')">
        <img  src="../../assets/logo/logo.png" alt="">
        <!-- <img v-if="!isShow" src="../../assets/webImg/logo.png" alt="">
        <p>中国中铁</p> -->
      </div>
      <div class="menuBox">
        <ul class="menuList">
          <li :class="{'active':pageActive == 1 || pageActive == 7 }" @click="handleChange(1,'/')">首页</li>
          <li :class="{'active':pageActive == 2}" @click="handleChange(2,'/campusRecruitment')">校园招聘</li>
          <!-- <li :class="{'active':pageActive == 3}" @click="handleChange(3,'/socialRecruitment')">社会招聘</li> -->
          <li :class="{'active':pageActive == 3}" @click="handleUrl">社会招聘</li>
          <li :class="{'active':pageActive == 4}" @click="handleChange(4,'/specialRecruitment')">专项招聘</li>
          <!-- <li :class="{'active':pageActive == 5}" @click="handleChange(5,'/personnelTraining')">人才发展</li> -->
          <li :class="{'active':pageActive == 6}" @click="handleChange(6,'/askedQuestion')">常见问题</li>
        </ul>
        <!-- <div class="loginRegister" v-if="!isLogin">
          <p @click="handleOpen('goLogin')">登录</p>
          <crec-button type="primary" size="small" @click="handleOpen('goRegister')">注册</crec-button>
        </div> -->
        <!-- <crec-dropdown v-if="isLogin">
          <div class="dropdownLine ant-dropdown-link">
            <p>{{loginUser}}</p>
            <crec-icon type="down" />
          </div>
          <crec-menu slot="overlay">
            <crec-menu-item @click="handleOpen('goLoginInfo')">个人中心</crec-menu-item>
            <crec-menu-item @click="handleChange(-1,'/deliveryRecords')">投递记录</crec-menu-item>
            <crec-menu-item @click="handleLoginOut">退出登录</crec-menu-item>
          </crec-menu>
        </crec-dropdown> -->
<!--        <el-dropdown v-if="isLogin">-->
<!--          <div class="dropdownLine el-dropdown-link">-->
<!--            <p>{{loginUser}}</p>-->
<!--            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--          </div>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item @click.native="handleOpen('goLoginInfo')">个人中心</el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="handleChange(-1,'/deliveryRecords')">投递记录</el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="handleLoginOut">退出登录</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
      </div>
    </div>
    <login-dialog :show="goLogin" @closeValue="handleCloseLogin" />
    <register-dialog :show="goRegister" @closeValue="handleCloseRegister" />
    <login-info-dialog :show="goLoginInfo" @closeValue="handleCloseLoginInfo" @loginOut="loginOut" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import { getWebToken, removeWebToken } from '@/utils/auth'
import { RegexUtil } from "@/utils/base/RegexUtil";
import LoginDialog from "../../components/WebPageComponent/login/LoginDialog.vue";
import RegisterDialog from "../../components/WebPageComponent/login/RegisterDialog.vue";
import LoginInfoDialog from "../../components/WebPageComponent/login/LoginInfo.vue";

export default {
  name:'HeaderIndex',
  components:{
    LoginDialog,
    RegisterDialog,
    LoginInfoDialog
  },
  data(){
    return{
      isActive: 1,
      isShow: true,
      isLogin: false,
      loginUser: '',

      goLogin: false,
      goLoginInfo: false,
      goRegister: false,
    }
  },
  watch:{
    $route: {
      immediate: true,
      handler(to) {
        // 监听路由变化
        console.log(to,"=======")
        if(to.path==='/'){
          this.SET_PAGE_ACTIVE(1)
        }
        if(to.path==='/campusRecruitment'){
          this.SET_PAGE_ACTIVE(2)
        }
        if(to.path==='/specialRecruitment'){
          this.SET_PAGE_ACTIVE(4)
        }
        if(to.path==='/askedQuestion'){
          this.SET_PAGE_ACTIVE(6)
        }
      }
    },
    isShowActive(val){
      if(val != 1){
        this.isShow = true
      }else{
        this.isShow = true
      }
    },
    pageActive(val){
      setTimeout(()=>{
        if(val == 1){
          this.isShow = true
        } else {
          this.isShow = true
        }
        this.isPage = true;
        this.loginUser = localStorage.getItem("loginUser");
        if(!getWebToken()){
          this.isLogin = false;
        }
      },200)
    },
  },
  computed:{
    ...mapGetters(['pageActive','isShowActive'])
  },
  created() {
    this.loginUser = localStorage.getItem("loginUser");
  },
  mounted() {
    this.loginUser = localStorage.getItem("loginUser");
    if(!RegexUtil.isEmpty(getWebToken()) && !RegexUtil.isEmpty(this.loginUser)){
      this.isLogin = true;
    }
  },
  methods:{
    ...mapMutations({ SET_SHOW_ACTIVE:'webPage/SET_SHOW_ACTIVE', SET_PAGE_ACTIVE:'webPage/SET_PAGE_ACTIVE' }),

    handleOpen(val){
      this[val] = true
    },
    handleCloseRegister(val) {
      if (val === 'close') {
        this.goRegister = false
        return
      }
      if(val){
        this.goLogin = true
      }
      this.goRegister = false
    },
    //社会招聘
    handleUrl(){
      window.open('https://www.crecg.com/web/rlzy65/rczp11/index.html')
    },
    handleCloseLoginInfo(){
      this.goLoginInfo = false
    },
    handleCloseLogin(val) {
      if (val === 'close') {
        this.goLogin = false
        return
      }
      if(val){
        this.goLogin = false
        this.handleOpen('goRegister');
      } else {
        setTimeout(() => {
          this.loginUser = localStorage.getItem("loginUser");
          if(!RegexUtil.isEmpty(getWebToken()) && !RegexUtil.isEmpty(this.loginUser)){
            this.isLogin = true;
          }
          this.goLogin = false
        },200)
      }
    },
    handleChange(val, path){
      this.SET_PAGE_ACTIVE(val);
      if(val == 1){
        this.SET_SHOW_ACTIVE(1);
        // window.addEventListener("scroll", this.scrolling);
        this.isShow = true
      } else {
        this.isShow = true
      }
      this.$router.push(path)
    },

    handleLoginOut() {
      const that = this
      this.$confirm({
        content: '确定退出当前登录用户吗？',
        title: '提示',
        onOk() {
          removeWebToken();
          that.loginUser = null;
          that.isLogin = false;
          localStorage.setItem('loginUser', '');
          localStorage.setItem('openType', null);
          that.$router.push('/');
        }
      })
      // this.$confirm('确定退出当前登录用户吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
        
      // }).catch(() => {});
    },

    loginOut(){
      this.loginUser = null;
      this.isLogin = false;
      localStorage.setItem('loginUser', '');
      localStorage.setItem('openType', null);
    }

  },
}
</script>

<style lang="less" scope>
.webHeader{
  width: 100%;
  position: fixed;
  top:0;
  height: @headerHeight;
  z-index: 200;
  .webHeaderContent{
    width: @webWidth;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo1{
      display: flex;
      align-items: center;
      cursor: pointer;
      // & img{width: 50px}
      & p{margin: 0 0 0 10px;font-size: 22px;font-weight: 600}
      .img {
        max-width: 300px;
         width: 100%;
      }
    }
    .menuBox{
      display: flex;
      align-items: center;
    }
    .menuList{
      display: flex;
      align-items: center;
      list-style: none;
      margin: 0 20px 0 0;
      padding: 0;
      background-color: transparent;
      & li{
        margin: 0 30px;
        font-size: 20px;
        cursor: pointer;
        line-height: 40px;
        &.active{
          position: relative;
          font-weight: 600;
          &::after{
            content: '';
            display: inline-block;
            width: 60%;
            height: 3px;
            border-radius: 8px;
            position: absolute;
            left: 50%;
            bottom: 0;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
          }
        }
      }
    }
    .loginRegister{
      display: flex;
      align-items: center;
      & p{margin: 0 16px 0 0;font-size: @fs14;font-weight: 600;cursor: pointer}
      .el-button{font-size: @fs14;border: none}
    }
    .dropdownLine{
      cursor: pointer;
      display: flex;
      align-items: center;
      & img{width: 40px;height: 40px;border-radius: 50%;display: block}
      & p{font-size: @fs14;margin: 0 0 0 10px;font-weight: 600}
      .el-icon-arrow-down{
        &::before{
          font-weight: 600;
        }
      }
    }
  }
}
.webHeader1{
  background-color: transparent;
  .webHeaderContent{
    .logo1{
      & p{color: @fontColorWhite;}
    }
    .menuList{
      li{
        color: @fontColorWhite;
        &.active{
          color: @fontColorWhite;
          &::after{
            background-color: @fontColorWhite;
          }
        }
      }
    }
    .loginRegister{
      & p{color: @fontColorWhite;}
      .el-button{background-color: @fontColorWhite;color: @primary}
    }
    .dropdownLine{
      & p{color: @fontColorWhite}
      .anticon-down{color: @fontColorWhite;margin-left: 6px}
    }
  }
}
.webHeader2{
  background-color: @fontColorWhite;
  .webHeaderContent{
    .logo1{
      & p{color: @primary;}
    }
    .menuList{
      li{
        color: #333333;
        &.active{
          color: @primary;
          &::after{
            background-color: @primary;
          }
        }
      }
    }
    .loginRegister{
      & p{color: #333333;}
      .el-button{background-color: @primary;color: @fontColorWhite}
    }
    .dropdownLine{
      & p{color: #333333}
      .anticon-down{color: #333333;;margin-left: 6px}
    }
  }
}
</style>
